import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import Immutable from "immutable";
import merge from "lodash/merge";
import { createSelector } from "reselect";

import { flattenObject } from "../../lib/formUtils";

/**
 * FormErrorOverview
 */
class FormErrorOverview extends Component {
  static propTypes = {
    schema: PropTypes.instanceOf(Immutable.Map).isRequired,
    t: PropTypes.func.isRequired,
    // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
    errors: PropTypes.object,
    // eslint-disable-next-line react/no-unused-prop-types
    submitFailed: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
    schemaErrors: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
    submitErrors: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types,react/no-unused-prop-types
    asyncErrors: PropTypes.object
  };
  static defaultProps = {
    errors: null,
    schemaErrors: null,
    submitErrors: null,
    asyncErrors: null
  };

  getFieldTitle(fieldName, fieldError) {
    const { t } = this.props;

    if (fieldName === "err") {
      return fieldError;
    }

    const fieldPath = fieldName.split(".").reduce((carry, part) => {
      if (/\D/.test(part)) {
        carry.push("properties");
        carry.push(part);
      } else {
        carry.push("items");
      }
      return carry;
    }, []);

    const schema = this.props.schema.getIn(fieldPath);

    if (fieldError && fieldError.keyword === "checkQuantityIsApplied") {
      return t("productsNotCorrectlyDistributed", fieldError.params);
    }

    const title = ((schema && schema.get("title")) || t(fieldName)).replace(/<.*?>/gim, "");

    if (/^items\.[0-9]{1,}\.quantity$/.test(title)) {
      return fieldError;
    }
    return `${t("Field")}: "${title}" - ${fieldError}`;
  }

  render() {
    const { errors } = this.props;

    if (!errors) {
      return null;
    }

    return (
      <div className="Cart__ValidationErrors">
        <ul>
          {Object.keys(errors).map(fieldName => (
            <li key={fieldName}>
              <span>{this.getFieldTitle(fieldName, errors[fieldName])}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

const selectErrors = createSelector(
  [
    (state, props) => props.schemaErrors,
    (state, props) => props.submitFailed,
    (state, props) => props.submitErrors,
    (state, props) => props.asyncErrors
  ],
  (schemaErrors, submitFailed, submitErrors, asyncErrors) => {
    const ignoreIfContains = /dataPath|schemaPath/;

    let errors = flattenObject(schemaErrors, ".", ignoreIfContains);

    if (submitFailed) {
      errors = merge(
        flattenObject(schemaErrors, ".", ignoreIfContains),
        flattenObject(asyncErrors, ".", ignoreIfContains),
        flattenObject(submitErrors, ".", ignoreIfContains)
      );
    }

    if (Object.keys(errors).length === 0) {
      return null;
    }
    return errors;
  }
);

export default translate()(
  connect((state, props) => ({
    errors: selectErrors(state, props)
  }))(FormErrorOverview)
);
